// © 2015-2021 WDNA - All Rights Reserved

import { RedirectProps, RouteProps } from 'react-router';

// Main
import Login from './containers/Login';
import Forgot from './containers/Forgot';
import Logout from './containers/Logout';
// Layout
import EmptyPage from './loaders/EmptyPage';
import Error404 from './loaders/Error404';
import Landing from './loaders/Landing';
import Settings from './loaders/Settings';

export const redirects: RedirectProps[] = [
  {
    from: '/404',
    to: '/404/main',
  },
];

export const tabs: RouteProps[] = [
  {
    component: EmptyPage,
    path: '/emptypage',
  },
  {
    component: Error404,
    path: '/404/main',
  },
  {
    component: Landing,
    path: '/landing',
  },
  {
    component: Settings,
    path: '/settings',
  },
];

export const main: RouteProps[] = [
  {
    component: Login,
    path: '/login'
  },
  {
    component: Forgot,
    path: '/forgot'
  },
  {
    component: Logout,
    path: '/logout'
  }
];
